/** @jsxImportSource @emotion/react */
import Typography from '@mui/material/Typography'
import InfiniteScroll from 'react-infinite-scroll-component'

import Input from 'components/Input'
import { ReactComponent as SearchIcon } from 'components/Autosuggest/icons/search.svg'
import { PageLoader } from 'components/PageLoader'
import { PAGE_CONTAINER } from 'components/Layout/Layout'
import * as commonClasses from '../styles'
import { Form, QUARTILE_OPTIONS } from '../Form'
import { HeaderButtons } from '../HeaderButtons'
import { useTrainingGradeEdit } from './hooks'

export const TrainingGradeEdit = () => {
  const {
    creating,
    loading,
    exportingTrainingData,
    title,
    question,
    search,
    trainingData,
    handleSearch,
    handleCreateSubmit,
    handleEditSubmit,
    handleExport,
    handleAddContent,
    handleCreateCancel,
    handleDelete,
    loadMore,
    hasMore,
    called,
  } = useTrainingGradeEdit()

  if (loading && !trainingData.length && !called) {
    return <PageLoader />
  }

  return (
    <div css={commonClasses.container} data-testid="grade-editor-form-wrapper">
      <Typography variant="title3" css={commonClasses.title} data-testid="grade-editor-title">
        {title}
      </Typography>

      <HeaderButtons
        exportDisabled={exportingTrainingData || !trainingData?.length}
        onExport={() => handleExport(false)}
        onAddContent={handleAddContent}
      />

      <Typography css={commonClasses.question}>{question}</Typography>

      <Input
        css={commonClasses.searchInput}
        label="Search by text"
        value={search}
        onChange={handleSearch}
        startAdornment={<SearchIcon css={commonClasses.searchIcon} />}
        fullWidth
      />

      {creating && <Form onSubmit={handleCreateSubmit} onCancel={handleCreateCancel} />}

      <InfiniteScroll
        dataLength={trainingData.length}
        next={loadMore}
        hasMore={hasMore}
        loader={<PageLoader />}
        css={commonClasses.infiniteScroll}
        scrollableTarget={PAGE_CONTAINER}
      >
        {trainingData.map((item) => (
          <Form
            key={item.id}
            initialValues={{
              id: item.id,
              response: item.answerText,
              quartile: QUARTILE_OPTIONS.find((q) => q.id === String(item.quartile)) || QUARTILE_OPTIONS[0],
              quartileExplanation: item.quartileExplanation,
              responseFeedback: item.responseFeedback,
            }}
            onSubmit={handleEditSubmit}
            onDelete={handleDelete}
          />
        ))}
      </InfiniteScroll>

      {!trainingData?.length && !creating && <Typography css={commonClasses.emptyData}>Empty Training Data</Typography>}
    </div>
  )
}
